/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { financialsKvDtoSchema } from "./financialsKvDtoSchema.ts";
import { z } from "zod/v4";

export const financialsTermsAnalysisDtoSchema = z.object({
  averageContractLabel: z.optional(z.string()),
  get averageContract() {
    return z.array(financialsKvDtoSchema).optional();
  },
  termsNegotiatedLabel: z.optional(z.string()),
  termsNegotiated: z.optional(z.array(z.string())),
});
